import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { ReportsService } from '../../../services/reports.service';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  RadioQuestionModel,
  SelectQuestionModel,
  MultipleQuestionModel,
  ExplainQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { ParkingDiscCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'parking-disc-policy',
  templateUrl: './parking-disc.component.html',
})
export class ParkingDiscComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = ParkingDiscCopy;
  parkingDisc = new RadioQuestionModel();
  reconsider = new RadioQuestionModel();
  cancellation = new SelectQuestionModel();
  errorsMultipleQuestions = new MultipleQuestionModel();
  explain = new ExplainQuestionModel();

  constructor(
    public global: Global,
    private reportsService: ReportsService,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setParkingDiscQuestion();
    this.setReconsiderQuestion();
    this.setCancellationSelectQuestion();
    this.setErrorsMultipleSelectQuestion();
    this.setExplainQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setParkingDiscQuestion() {
    this.parkingDisc.data = {
      title: this.textCopy.useParkingDiscsTitle,
      includeTitle: true,
      answers: [
        {
          text: 'no',
          value: '0',
        },
        {
          text: 'on street',
          value: '1',
        },
        {
          text: 'off street',
          value: '2',
        },
        {
          text: 'both on and off street',
          value: '3',
        },
      ],
    };
  }
  onParkingDiscSelected(answerValue) {
    this.parkingDisc.valueSelected = answerValue;
  }

  setReconsiderQuestion() {
    this.reconsider.data = {
      title: this.textCopy.reconsiderTitle,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onReconsiderSelected(answerValue) {
    this.reconsider.valueSelected = answerValue;
  }

  setCancellationSelectQuestion() {
    this.cancellation.data = {
      title: this.textCopy.cancellationsTitle,
      includeTitle: true,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onCancellationSelected(answerValue) {
    this.cancellation.valueSelected = answerValue;
  }

  setErrorsMultipleSelectQuestion() {
    this.errorsMultipleQuestions.data = {
      questions: [
        {
          id: 0,
          text: 'driver not familiar with the scheme',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 1,
          text: 'not displayed',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 2,
          text: 'face down',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 3,
          text: 'obscured by base of windscreen',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 4,
          text: 'obscured by something else',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 5,
          text: 'time not set or wrong time set',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 6,
          text: 'time expired',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 7,
          text: 'time extended',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 8,
          text: 'two discs displayed',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
      ],
    };
  }
  onErrorsMultipleQuestionsSelected(answerValue) {
    this.errorsMultipleQuestions.valuesSelected = answerValue;
  }

  setExplainQuestion() {
    this.explain.data = {
      title: this.textCopy.explainTitle,
      includeTitle: true,
      name: "'Disc zone'",
      validList: ['0', '1', '3', '4', '5', '6', '7', '8', '9', '10'],
      exampleItem: 'Parking discs',
    };
  }
  onExplainQuestionSelected(answerValue) {
    this.explain.valueSelected = answerValue.answerSelected;
    this.explain.validationSelected = answerValue.validationSelected;
    this.explain.validationText = answerValue.validationText;
  }

  setSelectedValues() {
    this.parkingDisc.valueSelected = this.policiesAnswers['31_1'];
    this.reconsider.valueSelected = this.policiesAnswers['31_2'];
    this.cancellation.valueSelected = this.policiesAnswers['31_3'];
    this.errorsMultipleQuestions.valuesSelected = [
      { id: 0, value: this.policiesAnswers['31_4_1'] },
      { id: 1, value: this.policiesAnswers['31_4_2'] },
      { id: 2, value: this.policiesAnswers['31_4_3'] },
      { id: 3, value: this.policiesAnswers['31_4_4'] },
      { id: 4, value: this.policiesAnswers['31_4_5'] },
      { id: 5, value: this.policiesAnswers['31_4_6'] },
      { id: 6, value: this.policiesAnswers['31_4_7'] },
      { id: 7, value: this.policiesAnswers['31_4_8'] },
      { id: 8, value: this.policiesAnswers['31_4_9'] },
    ];
    this.explain.valueSelected = this.policiesAnswers['31_5'];
    this.explain.validationSelected = this.policiesAnswers['31_6'];
    this.explain.validationText = this.policiesAnswers['31_7'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '31_1', description: this.parkingDisc.valueSelected },
      { id: '31_2', description: this.reconsider.valueSelected },
      { id: '31_3', description: this.cancellation.valueSelected },
      { id: '31_5', description: this.explain.valueSelected },
      { id: '31_6', description: this.explain.validationSelected },
      { id: '31_7', description: this.explain.validationText },
    ];

    this.errorsMultipleQuestions.valuesSelected.forEach((selectedValue, index) => {
      policyList.push({ id: `31_4_${index + 1}`, description: selectedValue.value });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
